import { format } from 'date-fns-tz'
import { MembershipStatus, PlatformName, RolesEnum, UserWhere } from '__generatedTypes__/globalTypes'

export type Filters = {
  selectedPlatform: {
    id: string
    title: string
  }
  role?: RolesEnum
  status: {
    id: MembershipStatus
  }
  duration: {
    id: string
  }
  expirationDate: {
    from?: Date
    to?: Date
  }
}

export function getFilterParams(filters: Partial<Filters>): UserWhere {
  const where: UserWhere = {}

  if (filters.selectedPlatform) {
    where.selectedPlatform = filters.selectedPlatform.id as PlatformName
  }

  if (filters.role) {
    where.role = filters.role
  }

  if (filters.status) {
    where.membershipStatus = filters.status.id
  }

  if (filters.duration) {
    where.duration = filters.duration.id
  }

  if (filters.expirationDate?.from || filters.expirationDate?.to) {
    where.expirationDateRange = {
      from: filters.expirationDate?.from ? format(filters.expirationDate.from, "yyyy-MM-dd'T00:00:00.000'") : undefined,
      to: filters.expirationDate?.to ? format(filters.expirationDate.to, "yyyy-MM-dd'T23:59:59.999'") : undefined,
    }
  }

  return where
}
